import React from 'react';
import _ from 'lodash';
import useProductQueryParams from 'src/hooks/use-product-query-params';
import { MultiSelectSubcategoryPill } from './multi-select-subcategory-pill';
import { Container, PillsContainer } from './styles';

type MultiSelectSubcategoryPillsProps = React.HTMLAttributes<HTMLDivElement> & {
  subcategories: { key: string; label: string; value: string }[];
};

export const MultiSelectSubcategoryPills = ({
  subcategories,
  ...otherProps
}: MultiSelectSubcategoryPillsProps): JSX.Element | null => {
  const { queryParams } = useProductQueryParams();
  const selectedSubcategories = queryParams.subcategories ?? [];

  if (_.isEmpty(subcategories)) {
    return null;
  }

  return (
    <Container className='subcategories-pills' {...otherProps}>
      <PillsContainer>
        <MultiSelectSubcategoryPill
          key='all'
          label='All'
          selected={_.isEmpty(selectedSubcategories)}
          value=''
          selectedSubcategories={selectedSubcategories}
        />
        {_.map(subcategories, (subcategory) => (
          <MultiSelectSubcategoryPill
            key={subcategory.key}
            isSubcategory
            label={subcategory.label}
            selected={_.includes(selectedSubcategories, subcategory.value)}
            value={subcategory.value}
            selectedSubcategories={selectedSubcategories}
          />
        ))}
      </PillsContainer>
    </Container>
  );
};
